import { useEffect } from "react";

import { PreloadedQuery } from "react-relay";

import { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content";
import { UserLocale } from "@/utils/useGeoCurrency";

import { AppPricingData } from "../../../../contentful";
import { SoftwareCompassPricingPageTemplate } from "../../../../templates/software/compass/pricing/src/software-compass-pricing-page.template";

export type SoftwareCompassPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const SoftwareCompassPricingPageRelay = ({
    pricing,
    countryCode,
    pricingContent,
    queryRef
}: SoftwareCompassPricingPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProviderRelay
            productId="compass"
            pricingContent={pricingContent}
            queryRef={queryRef}
        >
            <div data-testid="compass-pricing-page">
                <SoftwareCompassPricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </div>
        </PricingContentContextProviderRelay>
    );
};
